import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { A11y, Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import Slide1 from '../../images/slider/slide-1.jpg'
import Slide2 from '../../images/slider/slide-2.jpg'
import Slide3 from '../../images/slider/slide-3.jpg'
// import Slide6 from '../../images/slider/hero-text.jpg'

/* heroTeam */
// import heroTeam from '../../images/team/hero-team/1.jpg'
// import heroTeam2 from '../../images/team/hero-team/2.jpg'
// import heroTeam3 from '../../images/team/hero-team/3.jpg'
// import heroTeam4 from '../../images/team/hero-team/4.jpg'
// import { Link } from 'react-router-dom'

export const LeftArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
  </svg>
)

// RightArrowIcon.jsx
export const RightArrowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
  </svg>
)

const Hero = () => {
  return (
    <section className="wpo-hero-slider">
      <Swiper
        className="swiper-container"
        modules={[Navigation, A11y, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        loop={true}
        speed={1800}
        parallax={true}
        autoplay={{
          delay: 1000, // 3 seconds between slides
          disableOnInteraction: false, // Keep autoplay after user interaction
        }}
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        pagination={
          {
            // Uncomment and customize if needed
            // clickable: true,
            // el: '.swiper-pagination',
            // type: 'fraction',
            // renderFraction: (currentClass, totalClass) => {
            //   return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`
            // },
          }
        }
      >
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{
              backgroundImage: `url(${Slide3})`,
            }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-sub-title">
                  <h2>APEX COMPANY</h2>
                   <span>Solution for all Industrial</span>
<p>We offer the most complete industrial solution in country the most complete industrial</p>
                  {/* <h3> DESIGNED TO INSPIRE & BUILT TO LAST</h3> */}
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{ backgroundImage: `url(${Slide2})` }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-sub-title">
                 <h2>APEX COMPANY</h2>
                   <span>Solution for all Industrial</span>
<p>We offer the most complete industrial solution in country the most complete industrial</p>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div
            className="slide-inner slide-bg-image"
            style={{ backgroundImage: `url(${Slide1})` }}
          >
            <div className="container">
              <div className="slide-content">
                <div className="slide-sub-title">
                 <h2>APEX COMPANY</h2>
                   <span>Solution for all Industrial</span>
<p>We offer the most complete industrial solution in country the most complete industrial</p>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        {/* <div className="swiper-pagination"></div> */}
        <div className="swiper-button-prev custom-prev">
          <LeftArrowIcon />
        </div>
        <div className="swiper-button-next custom-next">
          <RightArrowIcon />
        </div>
      </Swiper>
      {/* <div className="hero-team">
                <ul>
                    <li><img src={heroTeam} alt="hero-team" /></li>
                    <li><img src={heroTeam2} alt="hero-team" /></li>
                    <li><img src={heroTeam3} alt="hero-team" /></li>
                    <li><img src={heroTeam4} alt="hero-team" /></li>
                    <li>
                        <Link to="/">
                            <svg width="32" height="8" viewBox="0 0 32 8" fill="none">
                                <rect width="8" height="8" rx="4" fill="white" />
                                <rect x="12" width="8" height="8" rx="4" fill="white" />
                                <rect x="24" width="8" height="8" rx="4" fill="white" />
                            </svg>
                        </Link>
                    </li>
                </ul>
                <span>Meet Our Team</span>
            </div> */}
      {/* <AnchorLink href="#about" className="scroll-btn">
        <span>Scroll For More</span>
        <div className="scroll-befor">
          <img src={arrow} alt="" />
        </div>
      </AnchorLink> */}
    </section>
  )
}

export default Hero
